import {NumberUtils} from './number.utils';
import {CommonConstant} from '../app.constants';
import * as Sentry from '@sentry/browser';
import {Currency} from '../../models/Billing/currency';
import {Params} from '@angular/router';

declare var require: any;
const clone = require('clone');
const equal = require('deep-equal');

export class ObjectUtils {
  /**
   * This helper use to deep clone an object. Keep the same content and type as well
   * For more details: https://github.com/pvorb/clone
   * @param obj
   * @returns {any}
   */
  static deepClone(obj: any): any {
    const clonedObj = clone(obj);
    return clonedObj;
  }

  /**
   * this helper will be used to format the currency value with currency code
   * We are supported 4 kind of currency code ('EUR', 'USD', 'DKK', 'NOK', 'SEK')
   * @param value
   * @param {number} currency
   * @returns {any}
   */
  static currencyFormat(value, currency = 0) {
    const normalizedValue = NumberUtils.normalizeNumberToString(value);
    let currencyString = '';

    switch (currency) {
      case 0:
        currencyString = CommonConstant.EUROPE_CURRENCY;
        break;
      case 1:
        currencyString = CommonConstant.US_CURRENCY;
        break;
      case 2:
        currencyString = CommonConstant.DANISH_KRONE_CURRENCY;
        break;
      case 3:
        currencyString = CommonConstant.NORWAY_CURRENCY;
        break;
      case 4:
        currencyString = CommonConstant.SWEDISH_CURRENCY;
        break;
      case 5:
        currencyString = CommonConstant.POUND_CURRENCY;
        break;
    }

    return normalizedValue + ' ' + currencyString;
  }

  /**
   * this helper will be used to format a number value to currency value
   * Example:
   * 1000 USD => $1,000
   * 1257000 EUR => €1,257,000
   * @param value
   * @param {number} currency
   * @returns {any}
   */
  static formatNumberToCurrencyBySymbolic(value, currency: Currency, fractionDigits?: number) {
    const normalizedValue = NumberUtils.formatNumberToString(value, fractionDigits);

    return currency.symbol + ' ' + normalizedValue;
  }

  static parseJSON(data: string) {
    let result = null;
    try {
      result = JSON.parse(data);
    } catch (error) {
      Sentry.captureException(error);
    }
    return result;
  }

  /**
   * parse a string to Angular request param
   * @param {string} requestString
   * @param {string} seperator
   * @returns {Params}
   */
  static parseRequestParamFromString(requestString: string, seperator = ':'): Params {
    if (!requestString) {
      return {};
    }

    const requestArr = requestString.split('&');
    const requestParam: Params = {};
    requestArr.forEach(p => {
      const key = p.split(seperator)[0];
      const value = p.split(seperator)[1];
      requestParam[key] = value;
    });
    return requestParam;
  }

  /**
   * A helper to campare two objects
   * @param {Object} a
   * @param {Object} b
   * @returns {any}
   */
  static isEquals(a: object, b: object) {
    return equal(a, b);
  }

  static isEmpty(obj: object) {
    return Object.keys(obj).length === 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/object.utils.ts